import React from 'react';
import { observer } from 'mobx-react-lite';
import InfiniteLoader from 'react-window-infinite-loader';
import { useTranslation } from 'react-i18next';
import { useRootStore } from '../../../../mobx/bridge';
import VariableSizeListWrapper from './VariableSizeListWrapper';
import styles from './InfiniteChannelList.module.css';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const InfiniteChannelList = observer(function InfiniteChannelList(props) {
  const { listHeight } = props;
  const { commonStore, channelStore } = useRootStore();
  const { t } = useTranslation();

  const channelsToDisplay = channelStore.getChannels;

  if (channelsToDisplay?.length === 0) {
    return (
      <div className={styles.placeholderTextContainer}>
        {t('InfiniteChannelList.StartConversationInfoMessage')}
      </div>
    );
  }

  const isItemLoaded = (index) =>
    !commonStore.locationHasMoreChannels || index < channelsToDisplay.length;

  const loadMoreItems = () => {
    commonStore.loadMoreChannels();
  };

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={
        commonStore.locationHasMoreChannels
          ? channelsToDisplay.length + 1
          : channelsToDisplay.length
      }
      loadMoreItems={loadMoreItems}
      threshold={4}
    >
      {({ onItemsRendered, ref }) => (
        <VariableSizeListWrapper
          onItemsRendered={onItemsRendered}
          itemRef={ref}
          listHeight={listHeight}
        />
      )}
    </InfiniteLoader>
  );
});
InfiniteChannelList.whyDidYouRender = true;
InfiniteChannelList.displayName = 'InfiniteChannelList';

export default InfiniteChannelList;
